import { Injectable } from '@angular/core';

import { modelosStorage } from "./data.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {FrotaNavigationService} from "../../frotas/shared/frota-navigation.service";
import {FrotasService} from "../../frotas/shared/frota.service";
import {frotasStorage} from "../../frotas/shared/data.service";

@Injectable()
export class ModeloService {

  constructor(
    private _frotaNavigationService: FrotaNavigationService,
    private _frotaService: FrotasService,

    private _autocompleteService: AutoCompleteService
  ) { }

  //session
  setSessionStorage(item: any) {
    var object: string = JSON.stringify(item);
    sessionStorage.setItem(modelosStorage + '-new', object);
  }

  getSessionStorage() {
    var item: string = sessionStorage.getItem(modelosStorage + "-new");
    return JSON.parse(item);
  }

  clearSessionStorage() {
    sessionStorage.removeItem(modelosStorage + "-new");
  }

  setSessionStorageFatherModule(item: any) {
    var object: string = JSON.stringify(item);
    sessionStorage.setItem(modelosStorage + '-father', object);
  }

  getSessionStorageFatherModule() {
    var item: string = sessionStorage.getItem(modelosStorage + "-father");
    return JSON.parse(item);
  }

  clearSessionStorageFatherModule() {
    sessionStorage.removeItem(modelosStorage + "-father");
  }

  templateResult = (function(state: any, isCreateNew: boolean) {
    var stateReturn: any,
      text: string;

    if (state.loading) {
      stateReturn = state.text;
    } else {
      if (state.id === -1) {
        if (isCreateNew) {
          stateReturn = this._autocompleteService.setNewTagInList(state);
        } else {
          stateReturn = this._autocompleteService.setNoCreateNew(state.text);
        }
      } else {
        if (state.text) {
          text = state.text;
        } else {
          var tipo: string;
          if (state.tipoBem) {
            tipo = state.tipoBem.tipo;
          }

          text = state.modelo + ' / ' + tipo;
        }
        stateReturn = $('<span>' + text + '</span>');
      }
    }

    return stateReturn;
  }.bind(this));

  returnToOtherForm(otherForm: string, Response: any) {
    if(Response) {
      var otherFormObject: any;

      if (otherForm === frotasStorage) {
        otherFormObject = this._frotaService.getSessionStorage();
        otherFormObject.modelo = Response;
        this._frotaService.setSessionStorage(otherFormObject);
      }
    }

    this._autocompleteService.clearSessionStorage(modelosStorage);

    if (otherForm === frotasStorage) {
      otherFormObject = this._frotaService.getSessionStorage();
      var frotasRoute = otherFormObject.thisRoute;
      if (otherFormObject.id) {
        this._frotaNavigationService.goToEdit(otherFormObject.id, frotasRoute);
      } else {
        this._frotaNavigationService.goToNew(frotasRoute);
      }
    }
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/modelos/shared/modelo.service.ts
 **/